module.exports = __webpack_public_path__ + "images/closegod14909b26169e051db01e461db65caf31f.svg";